export default __webpack_public_path__ + "static/media/surfing-1.da37b25a.jpg";